module.exports = __webpack_public_path__ + "static/media/Jeff Lin.0cca013a.png";